<nwm-menu></nwm-menu>
<div class="content col-xxl-10 offset-xxl-1">
  <article>
    @if (asOfDate) {
      <h1>Net Worth Details as of {{ dateFormat(asOfDate) }}</h1>
      <div class="net-worth-grid" [style]="`grid-template-columns: auto repeat(${clientColumns.length}, auto) auto;`">
        <header class="net-worth-grid-header">
          <span class="display-name" id="display-name-column"></span>
          @for (client of clientColumns; track $index) { <span>{{ client.clientName === 'Unknown' ? '' : client.clientName }}</span> }
          <span>Total</span>
        </header>

        @for (catParent of categorySort | keyvalue; track $index) {
          <header class="net-worth-parent">
            <span class="display-name">
              @if ((totals.totalsByParent[catParent.key]?.total || 0) > 0) {
                <button (click)="toggleView(catParent.key)" [class.active]="viewToggle[catParent.key]">{{ catParent.key }}</button>
              } @else {
                <span class="no-totals">{{ catParent.key }}</span>
              }
            </span>
          </header>
          <ul [id]="`${catParent.key}-view`" [attr.aria-expanded]="!viewToggle[catParent.key]">
            @for (category of catParent.value; track category) {
              @if (categoriesById[category].instruments.length > 0) {
                <header class="net-worth-category">
                  <span class="display-name">{{ categoriesById[category].categoryName }}</span>
                </header>
                <ul [id]="`${category}-view`">
                  @for (proxyId of categoriesById[category].instruments; track proxyId) {
                    <li class="net-worth-instrument">
                      <span class="display-name">{{ holdingsByProxyId[proxyId].instrumentDisplayName }}</span>
                      @for (client of clientColumns; track $index) {
                        @if (holdingsByProxyId[proxyId].holdingsByClientOrder[client.clientOrder] && holdingsByProxyId[proxyId].holdingsByClientOrder[client.clientOrder].value !== 0) {
                          <span class="value">
                            @if (holdingsByProxyId[proxyId].holdingsByClientOrder[client.clientOrder].currencyCode === "USD"){<strong>*</strong>}
                            {{ valueFormat(holdingsByProxyId[proxyId].holdingsByClientOrder[client.clientOrder].value, fxRate, holdingsByProxyId[proxyId].holdingsByClientOrder[client.clientOrder].currencyCode) }}
                          </span>
                        } @else {
                          <span class="value">-</span>
                        }
                      }
                      <span class="value">
                        {{ valueFormat(holdingsByProxyId[proxyId].total || 0, fxRate) }}
                      </span>
                    </li>
                  }
                </ul>
                <li class="net-worth-subtotal">
                  <span class="display-name">Subtotal</span>
                  @for (client of clientColumns; track $index) {
                    <span class="value">{{ totals.totalsByCategory[category].totalByClientOrder[client.clientOrder] ? currencyFormat(totals.totalsByCategory[category].totalByClientOrder[client.clientOrder], fxRate) : '-' }}</span>
                  }
                  <span class="value">{{ currencyFormat(totals.totalsByCategory[category].total) }}</span>
                </li>
              }
            }
          </ul>
          <li class="net-worth-parent-total">
            <span class="display-name">Total {{ catParent.key }}</span>
            @for (client of clientColumns; track $index) {
              <span class="value">{{ currencyFormat(totals.totalsByParent[catParent.key]?.totalByClientOrder?.[client.clientOrder] || 0) }}</span>
            }
            <span class="value">{{ currencyFormat(totals.totalsByParent[catParent.key]?.total || 0) }}</span>
          </li>
        }
        <li class="net-worth-total">
          <span class="display-name">Total</span>
          @for (client of clientColumns; track $index) {
            <span class="value">{{ currencyFormat(totals.netWorthTotals.totalByClientOrder[client.clientOrder] || 0) }}</span>
          }
          <span class="value">{{ currencyFormat(totals.netWorthTotals.total || 0) }}</span>
        </li>
      </div>
      <footer class="net-worth-footer">
        <p><strong>* USD converted to CDN currency at an exchange rate of: {{ valueFormat(fxRate) }}</strong></p>
        <p><strong>** All externally held accounts are as of the last values provided by the client.</strong></p>
      </footer>
    }
    @else {
      <h1>Net Worth</h1>
      <hr>
      @if (loadError) { <p>An error occurred while loading</p> }
    }
  </article>
</div>
